module.exports = __webpack_public_path__ + "media/images/avatar/12-246ea4c1b64785eee2b0fc47b768a588.jpg";